<template>
  <CardedForm
    :ref="ref_prop"
    :id="id"
    :title="title"
    :is_loading="is_loading"
    @on-submit-form="on_submit_form"
    :errors="errors"
    :message="inner_msg"
    @on-close-message="on_hide_message"
    :submit_btn_text="submit_btn_text"
    :submit_btn_color="submit_btn_color"
  >
    <div class="d-flex justify-space-between consent-fact-row">
      <div class="">
        <b class="black--text">SCAN LIMITT:</b>
      </div>
      <div class="flex-grow-1 text-right">
        <b class="red--text">{{ comma(parseInt(scan_limit) - 1) }}</b>
      </div>
    </div>
    <div
      v-for="(rec, table_name) in records"
      :key="table_name"
      class="d-flex justify-space-between consent-fact-row"
    >
      <div class="">
        Data Table: <b class="red--text">{{ table_name }}</b>
      </div>
      <div class="flex-grow-1 text-right">
        <b class="red--text">{{
          rec.length == 0
            ? "No "
            : comma(rec.length > scan_limit ? scan_limit - 1 : rec.length)
        }}</b>
        {{
          rec.length == 0
            ? "records affected"
            : (rec.length > scan_limit ? "+ " : "") +
              "Record(s) will be deleted"
        }}
      </div>
    </div>
    <div class="d-flex justify-space-between consent-fact-row">
      <div class="">
        <b class="black--text">TOTAL NO. OF RECORDS AFFECTED:</b>
      </div>
      <div class="flex-grow-1 text-right">
        {{ total > scan_limit ? "Over " : "" }}
        <b class="red--text">
          {{ comma(total) }} {{ total > scan_limit ? "+ " : "" }}</b
        >
        Record(s)
      </div>
    </div>
    <br />
    <template v-slot:clearbtnslot>
      <p class="black--text text-left text-h6">
        {{ clear_msg }}
      </p>
    </template>
  </CardedForm>
</template>

<script>
import CardedForm from "./CardedForm";
import Utils from "../lib/Utils";
import ServerClient from "../lib/ServerClient";
export default {
  name: "DeleteConcentForm",
  components: {
    CardedForm,
  },
  props: {
    submit_btn_color: {
      type: String,
      default: "red",
    },
    clear_msg: {
      type: String,
      default: "Are you sure, you want to delete this item ?",
    },
    submit_btn_text: {
      type: String,
      default: "Yes Delete Item",
    },
    title: {
      type: String,
      default: "Affected Records After Delete",
    },
    id: {
      type: String,
      default: "",
      required: true,
    },
    ref_prop: {
      type: String,
      default: "",
      required: true,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    seed: {
      type: Object,
      default: () => {
        return null;
      },
      required: true,
    },
  },
  data: () => {
    return {
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
      errors: [],
      inner_msg: "",
    };
  },
  methods: {
    comma(v) {
      return Utils.comma(v);
    },
    on_hide_message() {
      this.$emit("on-delete-success");
    },
    get_deps() {
      this.$emit("on-show-loader");
      this.errors = [];
      this.inner_msg = "";
      ServerClient.Shared.get_dependence(
        {
          seed: {
            ...this.seed,
          },
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("delete deps", res);
          this.records = res.records;
          this.total = res.total_affected;
          this.scan_limit = res.limit;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs[this.ref_prop].show_error_dialog();
        }
      );
    },
    on_submit_form() {
      //console.log(this.$refs);
      this.errors = [];
      this.inner_msg = "";
      this.$emit("on-show-loader");
      ServerClient.Shared.delete_items(
        {
          seed: {
            ...this.seed,
          }
        },
        (res) => {
          console.log("delete results ", res);
          this.$emit("on-hide-loader");
          this.inner_msg = this.message;
          this.$refs[this.ref_prop].show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs[this.ref_prop].show_error_dialog();
        }
      );
    },
  },
  mounted() {
    this.get_deps();
  },
};
</script>